import type { FaireProductEntity } from "../../entity_types/product";

export const p_tkbrgw2nzc: FaireProductEntity = {
  token: "p_tkbrgw2nzc",
  type: "product",
  name: "Original Sunshine Sauce",
  brandToken: "b_pffcprwxbv",
  brandName: "The Sunshine Sauce Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6f7141da7b766f17abcd22e091d582fc76df6d8d30777019919fc05abab97b49.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/960089939afda00c27f3b4ceea0ddeb59c38bad8c49af4c8f2e411d5118b0983.jpeg",
    "https://cdn.faire.com/fastly/63f3a6f84ee8f31115a444997c87c184e11773e88ff7ebef23fd2e5cd99b2f0d.jpeg",
  ],
  priceDollars: 6.86,
  description:
    "A craft hot sauce that balances a perfect blend of garlic, tomatoes, onion, and Arbol chiles. The unique and versatile flavor profile goes great on all of your favorite foods. Vegan, gluten-free, and all-natural.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:24.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
